/* Neyli : navigation entre les photos de la galerie principale (fiches produit uniquement).
   - Flèches « Image précédente » / « Image suivante » sur l'image + compteur « 1 / 5 ».
   - Balayage horizontal sur tablette (sur téléphone, le carrousel natif du thème gère déjà le glissement).
   - Quand le zoom optionnel est activé, le geste sur l'image sert à explorer la photo agrandie
     (pas de changement de photo au balayage) ; les flèches restent utilisables.
   - Changer de photo réinitialise la position du zoom sans modifier le mode zoom. */
(function () {
  if (window.__neilyGalleryNav) return;
  window.__neilyGalleryNav = true;

  var mqlDesktop = window.matchMedia('(min-width: 750px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CHEVRON =
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function items(list) {
    return Array.prototype.slice.call(list.querySelectorAll(':scope > .product__media-item'));
  }

  function currentIndex(list) {
    var all = items(list);
    if (!all.length) return 0;
    if (mqlDesktop.matches) {
      for (var i = 0; i < all.length; i++) if (all[i].classList.contains('is-active')) return i;
      return 0;
    }
    var left = list.scrollLeft;
    var best = 0;
    var dist = Infinity;
    all.forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft - all[0].offsetLeft - left);
      if (d < dist) {
        dist = d;
        best = i;
      }
    });
    return best;
  }

  function resetZoom(list) {
    items(list).forEach(function (item) {
      if (item._neilyZoomOut) item._neilyZoomOut();
    });
  }

  function zoomMode(gallery, list) {
    if (window.NeilyZoom && window.NeilyZoom.isModeOn(gallery)) return true;
    return items(list).some(function (item) {
      return item._neilyZoomIsOn && item._neilyZoomIsOn();
    });
  }

  function setup(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var list = viewer && viewer.querySelector('.product__media-list');
    if (!viewer || !list) return;
    if (viewer.querySelector(':scope > .neily-gnav')) return;
    if (items(list).length < 2) return;

    viewer.classList.add('neily-gnav-host');

    var nav = document.createElement('div');
    nav.className = 'neily-gnav';
    nav.innerHTML =
      '<button type="button" class="neily-gnav__btn neily-gnav__btn--prev" aria-label="Image précédente">' +
      CHEVRON +
      '</button>' +
      '<button type="button" class="neily-gnav__btn neily-gnav__btn--next" aria-label="Image suivante">' +
      CHEVRON +
      '</button>' +
      '<span class="neily-gnav__count" aria-hidden="true"></span>' +
      '<span class="visually-hidden neily-gnav__live" aria-live="polite"></span>';
    viewer.appendChild(nav);

    var prevBtn = nav.querySelector('.neily-gnav__btn--prev');
    var nextBtn = nav.querySelector('.neily-gnav__btn--next');
    var count = nav.querySelector('.neily-gnav__count');
    var live = nav.querySelector('.neily-gnav__live');
    var lastIndex = -1;
    var announce = false;

    function update() {
      var all = items(list);
      if (all.length < 2) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      var i = currentIndex(list);
      var txt = i + 1 + ' / ' + all.length;
      if (count.textContent !== txt) count.textContent = txt;
      if (i !== lastIndex) {
        lastIndex = i;
        if (announce) live.textContent = 'Image ' + (i + 1) + ' sur ' + all.length;
        announce = false;
      }
    }

    var raf = 0;
    function scheduleUpdate() {
      if (!raf)
        raf = requestAnimationFrame(function () {
          raf = 0;
          update();
        });
    }

    function go(step) {
      var all = items(list);
      if (all.length < 2) return;
      var i = currentIndex(list);
      var target = all[(i + step + all.length) % all.length];
      resetZoom(list);
      announce = true;
      if (mqlDesktop.matches && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(target.dataset.mediaId, false);
      } else {
        list.scrollTo({
          left: target.offsetLeft - all[0].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
        // Synchronise la miniature active sur mobile
        var thumbs = gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
        thumbs.forEach(function (li) {
          var b = li.querySelector('button');
          if (!b) return;
          if (li.dataset.target === target.dataset.mediaId) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
        all.forEach(function (el) {
          el.classList.toggle('is-active', el === target);
        });
      }
      scheduleUpdate();
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });
    // Un appui sur une flèche ne doit jamais déclencher le zoom de l'image dessous
    [prevBtn, nextBtn].forEach(function (b) {
      ['pointerdown', 'touchstart'].forEach(function (type) {
        b.addEventListener(
          type,
          function (e) {
            e.stopPropagation();
          },
          { passive: true }
        );
      });
    });

    // Balayage tactile sur tablette / écran large (le téléphone utilise le carrousel natif)
    var touch = null;
    list.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) {
          touch = null;
          return;
        }
        touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), zoom: zoomMode(gallery, list) };
      },
      { passive: true }
    );
    list.addEventListener(
      'touchend',
      function (e) {
        if (!touch || !mqlDesktop.matches) return;
        var start = touch;
        touch = null;
        if (start.zoom || zoomMode(gallery, list)) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - start.x;
        var dy = t.clientY - start.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5 || Date.now() - start.t > 800) return;
        go(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );
    list.addEventListener(
      'touchcancel',
      function () {
        touch = null;
      },
      { passive: true }
    );

    viewer.addEventListener('slideChanged', scheduleUpdate);
    list.addEventListener('scroll', scheduleUpdate, { passive: true });
    gallery.addEventListener('click', function (e) {
      if (e.target.closest('[id^="GalleryThumbnails"]')) setTimeout(scheduleUpdate, 0);
    });
    new MutationObserver(scheduleUpdate).observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    if (mqlDesktop.addEventListener) mqlDesktop.addEventListener('change', scheduleUpdate);
    update();
  }

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"] media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // La galerie est re-rendue lors d'un changement de variante
  var mo = new MutationObserver(function () {
    init();
  });
  document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (el) {
    mo.observe(el, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', init);
})();
